<img
  [src]="image(src)"
  [src-fallback]="empty"
  class="rounded-full object-cover"
  [class]="[height, width]"
  [alt]="'geral.perfil-usuario' | translate"
/>
